import React, { createContext } from 'react';
import { UseQueryResult } from 'react-query';

import { IPeopleFilterType } from 'store/reducers/people/people-reducer';

export interface PeopleSearchInfo {
  searchValue?: string;
  currentFilter?: IPeopleFilterType;
  searchFocused?: boolean;
  nlpSearchQuery?: UseQueryResult<any, Error>;
  searchInputRef?: React.RefObject<HTMLInputElement>;
  showHistory?: boolean;
  isLoading?: boolean;
  showLoadingScreen?: boolean;
  setShowHistory?: React.Dispatch<React.SetStateAction<boolean>>;
  sendSearch?: (search?: string) => void;
  setSearchValue?: React.Dispatch<React.SetStateAction<string>>;
  setCurrentFilter?: React.Dispatch<React.SetStateAction<IPeopleFilterType>>;
  setSearchFocused?: React.Dispatch<React.SetStateAction<boolean>>;
  openTabletSearch?: () => void;
  closeTabletSearch?: () => void;
}

export const PeopleSearchContext = createContext<PeopleSearchInfo>({
  searchValue: '',
  currentFilter: null,
  searchFocused: false,
  nlpSearchQuery: null,
  searchInputRef: null,
  showHistory: false,
  isLoading: false,
  showLoadingScreen: false,
  setShowHistory: () => {},
  sendSearch: () => {},
  setSearchValue: () => {},
  setCurrentFilter: () => {},
  setSearchFocused: () => {},
  openTabletSearch: () => {},
  closeTabletSearch: () => {},
});
